import React from "react";
import { useMessageGetter } from "react-message-context";
import { inject, observer } from "mobx-react";
import withAnimation from "../../../utils/withAnimation";
import {
  invalidTextAreaError,
  isValidText,
  resolveMaxRows,
  useUpdateIncluded,
} from "../../../utils/commonUtils";
import TextArea from "./TextArea";

const ContactReachability = observer(({ FeedbackStore }) => {
  const key = "reachability";
  const { feedback, updateError, updateValue, updateIncluded, contactByPhone } =
    FeedbackStore;
  const reachability = feedback.reachability;
  const msgs = useMessageGetter("feedback.form.reachability");

  // Update included property when contactByPhone value changes
  useUpdateIncluded(key, contactByPhone, updateIncluded);

  const handleOnChange = (value) => {
    updateError(key, isValidText(value) ? false : invalidTextAreaError());
    updateValue(key, value);
  };

  return (
    <div className="rof-contactReachability">
      <TextArea
        id={`ROF-${key}`}
        translations={msgs}
        value={reachability.value}
        error={reachability.error}
        rows={2}
        maxRows={resolveMaxRows()}
        maxLength={250}
        handleOnChange={handleOnChange}
        required={false}
        counter={true}
      />
    </div>
  );
});

export default withAnimation(inject("FeedbackStore")(ContactReachability));
export const ContactReachabilityNoAnimation =
  inject("FeedbackStore")(ContactReachability);
